import ResizableModal from '../../../../../ui/ResizableModal'
import { Button } from '../../../../../ui'
import InventoryItemFormFields from './InventoryItemFormFields'

const EditItemModal = ({ actions, open, state }) => (
  <ResizableModal
    className='font-sans'
    open={open}
    onClose={actions.handleCloseEditItemModal}
    width={820}
    height={760}
    minWidth={680}
    minHeight={560}
    footer={
      <>
        <Button
          onClick={actions.handleCloseEditItemModal}
          className='rounded-full bg-primary text-sm uppercase text-white'
          title='CERRAR'
          disabled={actions.updateItemMutation.isPending}
        />
        <Button
          type='submit'
          form='inventory-edit-item-form'
          className='rounded-full bg-accent2 text-sm uppercase text-white'
          title={actions.updateItemMutation.isPending ? 'GUARDANDO...' : 'GUARDAR CAMBIOS'}
          disabled={actions.updateItemMutation.isPending}
        />
      </>
    }
  >
    <div className='mx-auto w-full max-w-3xl'>
      <div className='mb-4 flex items-start justify-between gap-4'>
        <div>
          <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>Edición individual</p>
          <h3 className='mt-1 text-2xl font-semibold text-slate-950'>Editar item</h3>
          <p className='mt-1 text-sm text-slate-600'>
            Actualiza los atributos del catálogo sin salir de la vista de inventario.
          </p>
        </div>
      </div>

      <form id='inventory-edit-item-form' className='space-y-3 rounded-2xl bg-white p-4 shadow-sm' onSubmit={actions.handleEditItemSubmit}>
        <InventoryItemFormFields
          form={state.itemEditForm}
          onChange={state.setItemEditForm}
        />
      </form>
    </div>
  </ResizableModal>
)

export default EditItemModal
